var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrokenStarIcon = function SvgBrokenStarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 163,
    height: 163,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A6B3BA",
    strokeLinecap: "round",
    strokeWidth: 4,
    d: "M40.828 52.536C24.199 56.3 15.885 58.18 13.904 64.54c-1.973 6.354 3.691 12.985 15.027 26.24l2.934 3.428c3.217 3.765 4.833 5.65 5.556 7.976.723 2.332.48 4.847-.007 9.869l-.446 4.576c-1.71 17.69-2.568 26.532 2.61 30.459 5.177 3.927 12.964.345 28.525-6.821l4.035-1.852c4.421-2.041 6.631-3.055 8.977-3.055s4.556 1.014 8.984 3.055l4.021 1.852c15.568 7.166 23.355 10.748 28.526 6.828 5.184-3.934 4.326-12.776 2.616-30.466m8.037-25.848c11.336-13.25 17-19.88 15.027-26.241-1.974-6.36-10.295-8.247-26.924-12.005l-4.299-.974c-4.725-1.068-7.084-1.602-8.983-3.041-1.9-1.44-3.11-3.623-5.543-7.99l-2.217-3.975C91.795 21.198 87.516 13.52 81.115 13.52s-10.68 7.678-19.244 23.036"
  })));
};
export default SvgBrokenStarIcon;